/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud # Usage This API is used in the `https://yrityksille.elisa.fi/` pages. # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of products included in an employee product list or selection.
 */
export type EmployeeProductType = 'EPP' | 'Purchased_Device';

export const EmployeeProductType = {
    EPP: 'EPP' as EmployeeProductType,
    Purchased_Device: 'Purchased_Device' as EmployeeProductType
};

